import styled from 'styled-components'

export const PaymentSectionHeaderContainer = styled.div`
  margin-top: 15px;
  width: 100%;
`
export const PaymentSectionContainer = styled.div`
  margin-top: 10px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const PaymentStatusContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  margin-right: 25px;
`
